/**
 * Defines contracts for company membership administration.
 */
import { z } from "zod";
import { PhoneNumberSchema } from "./EscalationContract.js";
export const CompanyMembershipRoleSchema = z.enum(["COMPANY_ADMIN", "BRANCH_MANAGER"]);
export const CompanyMembershipStatusSchema = z.enum(["ACTIVE", "INVITED", "SUSPENDED", "REVOKED"]);
export const CompanyBranchReferenceSchema = z
    .object({
    name: z.string().min(1).max(200),
    slug: z.string().min(1).max(120),
})
    .strict();
export const CompanyBranchListResponseSchema = z
    .object({
    items: z.array(CompanyBranchReferenceSchema),
})
    .strict();
export const CompanyUserSchema = z
    .object({
    allBranches: z.boolean(),
    assignedBranches: z.array(CompanyBranchReferenceSchema),
    email: z.email(),
    fullName: z.string().min(1).max(200),
    isSelf: z.boolean(),
    membershipId: z.uuid(),
    role: CompanyMembershipRoleSchema,
    status: CompanyMembershipStatusSchema,
    updatedAt: z.iso.datetime({ offset: true }),
    userId: z.uuid(),
    whatsAppPhone: z.string().nullable(),
})
    .strict();
export const CompanyUserListQuerySchema = z
    .object({
    includeInactive: z
        .enum(["true", "false"])
        .default("true")
        .transform((value) => value === "true"),
})
    .strict();
export const CompanyUserListResponseSchema = z
    .object({
    items: z.array(CompanyUserSchema).max(500),
})
    .strict();
/**
 * Creates an active company user with a local password.
 * Managers require at least one branch, or `allBranches: true` (enforced in the API).
 */
export const CreateCompanyUserRequestSchema = z
    .object({
    allBranches: z.boolean(),
    branchSlugs: z.array(z.string().trim().min(1).max(120)).max(100),
    email: z.email().max(254),
    fullName: z.string().trim().min(1).max(200),
    password: z.string().min(8).max(128),
    reason: z.string().trim().min(5).max(1_000),
    role: CompanyMembershipRoleSchema,
    whatsAppPhone: PhoneNumberSchema.nullable().default(null),
})
    .strict();
/**
 * Updates an existing company membership. Password is optional.
 */
export const UpdateCompanyUserRequestSchema = z
    .object({
    allBranches: z.boolean(),
    branchSlugs: z.array(z.string().trim().min(1).max(120)).max(100),
    fullName: z.string().trim().min(1).max(200),
    password: z.string().min(8).max(128).optional(),
    reason: z.string().trim().min(5).max(1_000),
    role: CompanyMembershipRoleSchema,
    whatsAppPhone: PhoneNumberSchema.nullable().default(null),
})
    .strict();
export const MembershipMutationReasonSchema = z
    .object({
    reason: z.string().trim().min(5).max(1_000).optional(),
})
    .strict()
    .transform((value) => Object.freeze({
    reason: value.reason ?? "Cambio de estado desde administración.",
}));
//# sourceMappingURL=MembershipContract.js.map